import { ApiClientWrapper } from '@spike/api-client';
import { createContext } from 'react';

export interface BookingLocationContextValue {
    apiClientWrapper: ApiClientWrapper;
    timeZone: string;
}

export const BookingLocationContext = createContext<BookingLocationContextValue | null>(null);
